import { useMemo } from "react";
import {
  useGetEvaluationGroups,
  type EvaluationGroup,
  type GetEvaluationGroupsResponse,
} from "@services/evaluationService";


/**
 * Hook to get and transform evaluation groups data
 */
export function useEvaluationGroups(
  challenge?: boolean,
  enabled: boolean = true
) {
  const { data, isLoading, error, refetch } = useGetEvaluationGroups(
    challenge,
    enabled
  );

  const groups = data ?? [];

  const hasGroups = groups.length > 0;

  return {
    groups,
    rawData: data,
    isLoading,
    error,
    hasGroups,
    refetch,
  };
}
